
<template>
    <v-layout column>
      <section :class="$vuetify.breakpoint.name === 'xl' ? 'container' : ''">
        <v-container>
          {{ imageUrlToBase64($route.query.url) }}
        </v-container>
      </section>
    </v-layout>
  </template>
  
  <script>
    export default {
      computed: {
        token () {
          return this.$store.state.token
        },
        set_color () {
          return this.$store.state.color
        }
      },
      mounted() {
        this.imageUrlToBase64(this.$route.query.url).then(console.log)
      },
      methods: {
        async imageUrlToBase64(url) {
          const data = await fetch(url);
          const blob = await data.blob();
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
              const base64data = reader.result;
              resolve(base64data);
            };
            reader.onerror = reject;
          });
          // console.log(base64data)
        }

// imageUrlToBase64('https://lh3.googleusercontent.com/i7cTyGnCwLIJhT1t2YpLW-zHt8ZKalgQiqfrYnZQl975-ygD_0mOXaYZMzekfKW_ydHRutDbNzeqpWoLkFR4Yx2Z2bgNj2XskKJrfw8').then(console.log)
      }
    }
  </script>